import { Injectable } from '@angular/core';
import { CognitoUser, CognitoUserPool } from 'amazon-cognito-identity-js';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthorizationService {
    cognitoUser: any;
    userPool: any;
    constructor() {
        if (window['DHI_AUTH_ENV'] === undefined) {
            window['DHI_AUTH_ENV'] = { UserPoolId: 'us-east-1_TbCzbogus', ClientId: '5059c7r153gibf72ca80bogus' };
        }
        const { UserPoolId, ClientId } = window['DHI_AUTH_ENV'];
        this.userPool = new CognitoUserPool({ UserPoolId, ClientId });
    }

    register(username, email, password) {
        const attributeList = [];

        return new Observable((observer) => {
            this.userPool.signUp(username, email, password, attributeList, (err, result) => {
                if (err) {
                    console.log('signUp error', err);
                    observer.error(err);
                }

                this.cognitoUser = result.user;
                console.log('signUp success', result);
                observer.next(result);
                observer.complete();
            });
        });
    }

    confirmAuthCode(code, username) {
        const user = {
            Username: username,
            Pool: this.userPool,
        };

        return new Observable((observer) => {
            const cognitoUser = new CognitoUser(user);
            cognitoUser.confirmRegistration(code, true, function (err, result) {
                if (err) {
                    console.log(err);
                    observer.error(err);
                }
                console.log('confirmAuthCode() success', result);
                observer.next(result);
                observer.complete();
            });
        });
    }

    // confirmPassword can be separately built out as follows...
    confirmPassword(username, verificationCode, newPassword) {
        const password = {
            Username: username,
            Pool: this.userPool,
        };
        const cognitoUser = new CognitoUser(password);

        return new Promise((resolve, reject) => {
            cognitoUser.confirmPassword(verificationCode, newPassword, {
                onFailure(err) {
                    reject(err);
                },
                onSuccess() {
                    resolve('confirm password succeeded');
                },
            });
        });
    }
}
